import { render, staticRenderFns } from "./FactorDocumentsUploader.vue?vue&type=template&id=18d7dc52&scoped=true&"
import script from "./FactorDocumentsUploader.vue?vue&type=script&lang=ts&"
export * from "./FactorDocumentsUploader.vue?vue&type=script&lang=ts&"
import style0 from "./FactorDocumentsUploader.vue?vue&type=style&index=0&id=18d7dc52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d7dc52",
  null
  
)

export default component.exports